import { scriptRunner } from "@commons/domLoaded"
import { attachUuidToForm } from "@commons/uuid"
import { ClubTheme } from "./club/club.theme"
import { themeComponents } from "./theme.components"
import { ThemeHandler } from "./theme.handler"
import { ThemeService } from "./theme.service"
import { TrackingEvent } from "./trackingEvent"

const init = () => {
  const clubTheme = new ClubTheme(new TrackingEvent())
  const service = new ThemeService(clubTheme)
  const themeHandler = new ThemeHandler(service, themeComponents())

  themeHandler.apply()
}

scriptRunner(() => {
  init()
  attachUuidToForm()
})